// extracted by mini-css-extract-plugin
export var container = "styles-module--container--rPizv";
export var link = "styles-module--link--XBSaU";
export var section = "styles-module--section--RYLCq";
export var title = "styles-module--title--0bshQ";
export var titleContainer = "styles-module--titleContainer--NzOJh";
export var titleVisible = "styles-module--titleVisible--juQfE";